import { render, staticRenderFns } from "./PrivacyCheckbox.vue?vue&type=template&id=4989d701&scoped=true"
import script from "./PrivacyCheckbox.vue?vue&type=script&lang=ts"
export * from "./PrivacyCheckbox.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyCheckbox.vue?vue&type=style&index=0&id=4989d701&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989d701",
  null
  
)

export default component.exports